// DocumentLifecycleState — ingestion pipeline progression. Authoritative
// transitions live in IngestionService (S-033); other code reads only.
import { z } from "zod";
export const DocumentLifecycleStateSchema = z.enum([
    "received",
    "parsing",
    "stage1_complete",
    "stage2_review",
    "stage3_human",
    "indexed",
    "failed",
]);
export const DOCUMENT_LIFECYCLE_STATES = DocumentLifecycleStateSchema.options;
//# sourceMappingURL=DocumentLifecycleState.js.map